import { Stack } from "react-bootstrap";

export const StackHeader = (props) => (
  <Stack direction="horizontal" className="w-100 justify-content-between">
    {props.children}
  </Stack>
);
